import moment from "moment-timezone";
import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import CopyString from "../../utils/CopyString.jsx";

import { MODIFIED_AT_TIME_FORMAT } from "../../config.js";

import { OPERATIONS } from "../../../constants/operations.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class ProjectDetailsView extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project.details_panel"
  };

  render() {
    const { data, copyKey, copy } = this.props;

    if (!data) return null;

    const otpAvailable = data.operations
      ?.find(op => op.name === OPERATIONS.UPDATE)
      ?.fields?.some(field => field.name === "requiresUserVerification");

    return (
      <p className="clear-both">
        <strong>{copy(`${copyKey}.id`)}: </strong>
        {data.id && <CopyString copyText={data.id} displayText={data.id} />}
        <br />
        <strong>{copy(`${copyKey}.name`)}: </strong> {data.name}
        <br />
        {data.description && (
          <Fragment>
            <strong>{copy(`${copyKey}.description`)}: </strong>
            {data.description}
            <br />
          </Fragment>
        )}
        {Object.hasOwn(data, "requiresUserVerification") && otpAvailable && (
          <Fragment>
            <strong>{copy(`${copyKey}.otp_title`)}: </strong>
            {data.requiresUserVerification
              ? copy(`${copyKey}.otp_enabled`)
              : copy(`${copyKey}.otp_disabled`)}
            <br />
          </Fragment>
        )}
        <br />
        {data.ownedBy && (
          <Fragment>
            <strong>{copy(`${copyKey}.ownedBy`)}: </strong>
            {data.ownedBy.name}
            <br />
          </Fragment>
        )}
        {data.createdBy && (
          <Fragment>
            <strong>{copy(`${copyKey}.created_by`)}: </strong>
            {`${data.createdBy.name} (${data.createdBy.username})`}
            <br />
          </Fragment>
        )}
        {data.createdAt && (
          <Fragment>
            <strong>{copy(`${copyKey}.created_at`)}: </strong>
            {moment(data.createdAt).format(MODIFIED_AT_TIME_FORMAT)}
            <br />
          </Fragment>
        )}
        {data.updatedAt && (
          <Fragment>
            <strong>{copy(`${copyKey}.last_updated`)}: </strong>
            {moment(data.updatedAt).format(MODIFIED_AT_TIME_FORMAT)}
            <br />
          </Fragment>
        )}
      </p>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectDetailsView);
